var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangedViewFrontWithFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 6.50001C14.612 6.50001 13.9253 6.21442 13.3542 5.64323C12.783 5.07205 12.4974 4.38542 12.4974 3.58334C12.4974 2.78126 12.783 2.09462 13.3542 1.52344C13.9253 0.952262 14.612 0.666672 15.4141 0.666672C16.2161 0.666672 16.9028 0.952262 17.474 1.52344C18.0451 2.09462 18.3307 2.78126 18.3307 3.58334C18.3307 4.38542 18.0451 5.07205 17.474 5.64323C16.9028 6.21442 16.2161 6.50001 15.4141 6.50001ZM11.0391 29.8333V10.875H2.28906V7.95834H28.5391V10.875H19.7891V29.8333H16.8724V21.0833H13.9557V29.8333H11.0391Z",
    fill: "#C4C5CC80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0394 15.25C-11.1273 15.25 12.7894 22.25 26.2061 17",
    stroke: "#00D08480",
    strokeWidth: 2.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5396 14.6667L27.3729 16.4167L24.4562 22.25",
    stroke: "#00D08480",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangedViewFrontWithFocus);
export default __webpack_public_path__ + "static/media/ChangedViewFrontWithFocus.c94e1c07abee014b815dd600fd1c09d5.svg";
export { ForwardRef as ReactComponent };